import { render, staticRenderFns } from "./AdvisorsStat.vue?vue&type=template&id=e041037e&"
import script from "./AdvisorsStat.vue?vue&type=script&lang=js&"
export * from "./AdvisorsStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports